<template>
  <div class="home_module">
    <div class="home_banner">
      <home-banner></home-banner>
    </div>
    <div class="home_pt">
      <ping-tai></ping-tai>
    </div>
    <div class="home_summary">
      <home-summary></home-summary>
    </div>
    <div class="home_hoder">
      <share-hoder></share-hoder>
    </div>
    <div>
      <home-product></home-product>
    </div>
    <div>
      <home-news></home-news>
    </div>
  </div>
</template>
<script>
import homeBanner from './banner';
import pingTai from './pingtai';
import homeSummary from './homeSummary';
import shareHoder from './shareHoder';
import homeProduct from './homeProduct';
import homeNews from './homeNews';

export default {
  data() {
    return {};
  },
  components: {
    homeBanner,
    pingTai,
    homeSummary,
    shareHoder,
    homeNews,
    homeProduct
  },
  methods: {}
};
</script>
<style scoped>
.home_module {
  background-color: #f3f3f3;
  width: 100%;
  position: relative;
  top: 0;
  left: 0;
  z-index: 1;
}
.home_banner {
  min-height: 500px;
  width: 100%;
  position: relative;
  top: 0;
  left: 0;
  z-index: 6;
}
.home_pt {
  width: 100%;
  height: 260px;
  padding: auto 0;
}
.home_summary {
  min-height: 450px;
  width: 100%;
}
.home_hoder {
  min-height: 300px;
  width: 100%;
  text-align: center;
}
.home_product {
  width: 99%;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/views/home/home.vue